import { motion } from "framer-motion";

const REASONS = [
  {
    n: "01",
    t: "Full-stack across modern and legacy",
    d: "From Laravel monoliths to React + Node micro-services — we ship on the stack your business already runs.",
  },
  {
    n: "02",
    t: "AI-augmented engineering",
    d: "Cursor, Claude, Replit and Codex woven into our workflow — for faster delivery without sacrificing code quality.",
  },
  {
    n: "03",
    t: "Payments experience that scales",
    d: "Deep experience with Stripe, PayPal, Authorize.net and NMI — subscriptions, tokenization and 3DS included.",
  },
  {
    n: "04",
    t: "MVP to enterprise, same team",
    d: "Service-based flexibility. Scoped MVPs, long-running platform engineering, or dedicated squads.",
  },
  {
    n: "05",
    t: "Pune-based, globally minded",
    d: "India-based delivery for cost-effective, high-quality output — with overlap windows for US, EU and APAC clients.",
  },
  {
    n: "06",
    t: "HighLevel Certified Admin",
    d: "Officially certified to build, white-label and scale GoHighLevel sub-accounts — funnels, pipelines, SMS/email automation and multi-client agency infrastructure.",
  },
];

export default function WhyChoose() {
  return (
    <section
      id="why"
      data-testid="why-choose-section"
      className="relative border-t border-hairline py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4 md:sticky md:top-28 self-start">
          <span className="mono-label">[04] Why Beacon</span>
          <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl tracking-[-0.03em] leading-[0.98]">
            Six reasons teams pick us —{" "}
            <span className="text-[color:var(--accent)]">and stay</span>.
          </h2>
          <p className="mt-6 text-white/60 max-w-[36ch] text-[15px] leading-relaxed">
            We&apos;re not an outsourced feature factory. We are the engineering team you plug into
            your business — accountable, opinionated and delivering.
          </p>
        </div>

        <div className="md:col-span-8">
          {REASONS.map((r, i) => (
            <motion.div
              key={r.n}
              data-testid={`why-item-${r.n}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10% 0px" }}
              transition={{ duration: 0.55, delay: i * 0.04 }}
              className="group grid grid-cols-[64px_1fr] md:grid-cols-[96px_1fr] gap-6 md:gap-10 py-8 md:py-10 border-t border-hairline last:border-b"
            >
              <div className="font-mono text-white/40 text-[13px] pt-1">
                [{r.n}]
              </div>
              <div>
                <h3 className="font-display text-2xl md:text-3xl tracking-tight group-hover:text-[color:var(--accent)] transition-colors">
                  {r.t}
                </h3>
                <p className="mt-3 text-white/60 text-[15px] leading-[1.6] max-w-[58ch]">
                  {r.d}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
